import {
  GetImportExportHistoriesListSortBy,
  GetImportExportHistoriesListSource,
  GetImportExportHistoriesListType,
} from 'ap-openapi';

export const isValidType = (
  value: string
): value is GetImportExportHistoriesListType => {
  return Object.values(GetImportExportHistoriesListType).some(
    (v) => v === value
  );
};

export const isValidSource = (
  value: string
): value is GetImportExportHistoriesListSource => {
  return Object.values(GetImportExportHistoriesListSource).some(
    (v) => v === value
  );
};

export const isValidSortBy = (
  value: string | null
): value is GetImportExportHistoriesListSortBy => {
  return (
    value !== null &&
    Object.values(GetImportExportHistoriesListSortBy).some((v) => v === value)
  );
};
